import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { i18nLoadRequest } from "../../store/i18n/i18nActions";
import LS from "../localStorageUtils";

const languages = [
  { code: "en", id: 1, label: "English" },
  { code: "bg", id: 2, label: "Български" },
  { code: "fr", id: 3, label: "Français" },
  { code: "ru", id: 4, label: "Русский" },
  { code: "tr", id: 5, label: "Türkçe" },
];

export function useLanguageInit() {
  const dispatch = useDispatch();

  useEffect(() => {
    const lang = LS.get("lang") || "en";

    const selectedLang = languages.find((l) => l.code === lang) || languages[0];

    dispatch(
      i18nLoadRequest({
        langId: selectedLang.id,
        langCode: selectedLang.code,
      })
    );
  }, [dispatch]);
}
